<template>
  <div class="row">
    <div class="col-12">
      <div class=" align-items-center mb-2">
        <div class="row">
          <div class="col-9">
            <h4 class="mb-0 ml-75">
              <feather type="layers" class="font-medium-3 mr-1">
              </feather>
              Cases
            </h4>
          </div>
          <div class="col-3">
            <div class="d-flex align-items-center justify-content-end">
              <button type="button"
                      @click="showCreateCaseModel = true"
                      class="btn btn-primary btn-sm">
                <span class="text-nowrap">Create</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <SelectOptions
                label="Department"
                selectAppend="department"
                labelValue="name"
                :filter="{limit:0}"
                :modelValue.sync="selectedDepartment"
                :url="getDepartmentsUrl"
            />
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <label for="account-name">Sub Department</label>
            <select class="form-control" v-model="selectedSubDepartment">
              <option value="null">Select sub department</option>
              <option v-for="(item,index) in subDepartments" :value="item._id">{{ item.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <label for="account-name">Assign To</label>
            <select class="form-control" v-model="assignedTo">
              <option value="null">Select assignee</option>
              <option v-for="(item,index) in assigneeList" :value="item._id">{{ item.name }}</option>
            </select>
          </div>


        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <label for="account-name">Case No</label>
              <input type="text"  v-model="caseNo" class="form-control" placeholder="search"/>
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <label for="account-name">Search</label>
              <input type="text"  v-model="search" class="form-control" placeholder="search"/>
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <SelectOptions
                label="Assigned By"
                selectAppend="assignedBy"
                labelValue="email"
                :filter="{flag:'active'}"
                :modelValue.sync="assignedBy"
                url="v1/get-admin-user"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <button type="button" class="btn btn-primary btn-sm"  @click="onSubmitFilters" >Search</button>
          <button type="button" class="ml-1 btn btn-danger btn-sm" @click="clear" >Clear</button>
        </div>

      </div>
    </div>
    <CommonTable
        :url="url"
        :filteredData="filteredData"
        :tableHeaderValues="tableHeaderValues"
        :actions="actions"
        :deleteActions="deleteActions"
        :mutedData="mutedData"
        :storageKey="storageKey"
        :externalTotalRecord="externalTotalRecord"
        :show-per-page="true"
        class="w-100"
    />

    <CaseUpdateStatusModal :row="actionData" @completed="completedAction" :show="ShowCaseUpdateModal"
                           @hide="ShowCaseUpdateModal = false"/>
    <!--    <CaseActionModal :show="ShowCaseActionModal" @hide="ShowCaseActionModal = false"/>-->
    <CreateCaseModal @completed="completedAction" :show="showCreateCaseModel" @hide="showCreateCaseModel = false"/>
    <CaseLogsModal :data="rowData" @completed="completedAction" :show="ShowCaseLogsModal"
                   @hide="ShowCaseLogsModal = false"/>
    <CaseOtherDetailsModal :row="otherDetails" :show="ShowCaseOtherDetailsModal"
                           @hide="ShowCaseOtherDetailsModal = false"/>
    <TransactionDetailsModal :transactionId="transactionId" :show="ShowTransactionDetailsModal" @hide="ShowTransactionDetailsModal = false"/>
  </div>
</template>
<script>
import CaseTypeCreateModal from "../../CaseTypeCreateModal.vue";
import CaseUpdateStatusModal from "../../CaseUpdateStatusModal.vue";
import CaseActionModal from "../../CaseActionModal.vue";
import CreateCaseModal from "../../CreateCaseModal.vue";
import CaseLogsModal from "../../CaseLogsModal.vue";
import CaseOtherDetailsModal from "./CaseOtherDetailsModal.vue";
import TransactionDetailsModal from "./TransactionDetailsModal.vue";

export default {
  components: {
    CaseLogsModal,
    CreateCaseModal,
    CaseTypeCreateModal,
    CaseUpdateStatusModal,
    CaseActionModal,
    CaseOtherDetailsModal,
    TransactionDetailsModal
  },
  props: [],
  mounted() {
    localStorage.setItem("url", this.url);
    this.checkDataInStore(this.url)
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      assignedBy:null,
      filteredData:{},
      caseNo:'',
      search:'',
      subDepartments: [],
      selectedSubDepartment: null,
      selectedDepartment: null,
      assigneeList:[],
      department: null,
      assignedTo: null,
      getDepartmentsUrl: "v1/cms-get-department",
      ShowTransactionDetailsModal:false,
      transactionId:null,
      otherDetails: {},
      actionData: {},
      rowData: {},
      force: false,
      updateData: [],
      url: "v1/cms-get-case",
      storageKey: "cases",
      tableHeaderValues: [
        {
          title: "CASE NO",
          valueKey: "number",
          html: true,
          alter: function (value) {
            var html = "";
            if (value) {
              html = `<span class=" badge text-secondary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          },
        },
        {
          title: "Title",
          valueKey: "title",
          html: true,
          alter: function (value) {
            var html = "";
            if (value) {
              html = `<span class=" badge text-secondary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          },
        },
        {
          title: "TRANSACTION ID",
          valueKey: "transaction.uuid",
          html: true,
          alter: (value, row) => {
            let html = ''
            // html = `<span class=" badge text-primary">${value}</span>`
            html = `<span class="d-block text-primary font-weight-bold">${value}</span>`;
            html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <div class="badge badge-dark mt-1" style="cursor: pointer;">Show Details</div>
                    </div>
                </div>
                `
            return html
          },
          cta: (row) => {
                this.transactionId = row?.transaction?.uuid
                this.ShowTransactionDetailsModal = true
          }
        },
        {
          title: "Added By",
          valueKey: "type",
          html: true,
          alter: (value, row) => {
            var html = '`<span class=" badge text-secondary">N/A</span>`'
            if (typeof row.addedBy != 'undefined' && row.addedBy) {
              html = `<div class="grid">
                        <div class="row"><div class="text-dark  font-weight-bold ">${row.addedBy?.name}</div></div>
                        <div class="row"><div class="badge badge-light-primary mt-sm-1">${row.addedBy?.email}</div></div>
                      </div>`

            }

            return html
          },
        },
        {
          title: "Assigned To",
          valueKey: "type",
          html: true,
          alter: (value, row) => {
            var html = '<span class=" badge text-secondary">N/A</span>'
            if (typeof row.assignedTo != 'undefined' && row.assignedTo) {
              html = `<div class="grid">
                        <div class="row"><div class="text-dark  font-weight-bold ">${row.assignedTo?.name}</div></div>
                        <div class="row"><div class="badge badge-light-warning mt-sm-1">${row.assignedTo?.email}</div></div>
                      </div>`
            }
            return html
          },
        },
        {
          title: "Department",
          valueKey: "subDepartment",
          html: true,
          alter: function (value) {
            var html = ''
            if (value) {
              html = `<span class="badge badge-light-dark">${value?.name}</span>`
            }
            return html
          }
        },
        {
          title: "Type",
          valueKey: "type",
          html: true,
          alter: function (value) {
            var html = ''
            if (value == 'normal')
              html = `<span class="badge badge-success badge-sm">${value.replace(/^\s*\w/, c => c.toUpperCase())}</span>`
            else
              html = `<span class="badge badge-danger badge-sm">${value.replace(/^\s*\w/, c => c.toUpperCase())}</span>`

            return html
          },
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function (value) {
            var html = ''
            if (value == 0)
              html = `<span class="badge badge-light-success badge-glow badge-sm">Open</span>`
            else if (value == 1)
              html = `<span class="badge badge-light-warning badge-glow badge-sm">Close</span>`
            else
              html = `<span class="badge badge-light-danger badge-glow badge-sm">Final Close</span>`

            return html
          },
        },
        {
          title: 'Created At',
          valueKey: 'createdAt',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
        {
          title: 'Updated At',
          valueKey: 'updatedAt',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        {
          title: "Action",
          cta: (row, index) => {
            this.actionData = {
              subDepartment: row.subDepartment,
              id: row._id,
              status: row.status,
              assignedTo: row?.assignedTo
            }
            this.ShowCaseUpdateModal = true
          }
        },
        // {
        //   title: "Details",
        //   cta: (row, index) => {
        //     this.transactionId = row?.transaction?.uuid
        //     this.ShowTransactionDetailsModal = true
        //     // this.$router.push({name: 'transactions-detail', params: {id: row?.transaction?.uuid}})
        //   }
        // },
        {
          title: "Details",
          cta: (row, index) => {
            this.otherDetails = row
            this.ShowCaseOtherDetailsModal = true
          }
        },
        // {
        //   title: "Action",
        //   cta: (row, index) => {
        //     this.data = {
        //       name : row.name,
        //       id:row._id,
        //       status: row.status
        //     }
        //     this.showUpdateCaseTypeModel = true
        //   }
        // },
        {
          title: "Logs",
          cta: (row, index) => {
            this.rowData = {
              name: row.name,
              id: row._id,
              status: row.status,
            }
            this.ShowCaseLogsModal = true
          }
        }
      ],
      deleteActions: [
        // {
        //   title: "Delete",
        //   class: " ml-1 custom-control-primary",
        //   cta: (row, index) => {
        //     this.deleteRecord(row);
        //   }
        // }
      ],
      mutedData: [],
      externalTotalRecord: "",
      ShowCaseActionModal: false,
      ShowCaseUpdateModal: false,
      showCreateCaseModel: false,
      ShowCaseLogsModal: false,
      ShowCaseOtherDetailsModal: false
    };
  },
  methods: {
    onSubmitFilters() {

      let filterData = {}


      if(this.search != ''){
        filterData.search = this.search
      }
      if(this.caseNo != ''){
        filterData.number = this.caseNo
      }

      if(this.selectedSubDepartment){
        filterData.subDepartment = this.selectedSubDepartment
      }

      // if(this.selectedDepartment){
      //   filterData.selectedDepartment = this.selectedDepartment?._id
      // }

      if(this.assignedTo){
        filterData.assignedTo = this.assignedTo
      }

      if(this.assignedBy){
        filterData.assignedBy = this.assignedBy?.uuid
      }

      this.filteredData = filterData

    },
    clear(){
      this.search = ''
      this.caseNo = ''
      this.selectedSubDepartment = null
      this.selectedDepartment = null
      this.assignedTo = null
      this.assignedBy = null
      this.filteredData = {}




    },
    deleteRecord(row) {
      this.makeRequest("post", "v1/cms-update-case-status", {
        status: row.status == true ? 1 : 0,
        id: row._id,
        name: row.name
      });
    },
    completedAction() {
      this.$store.dispatch('renderPagination', !this.force);
      this.force = !this.force;
      this.ShowCaseLogsModal = false
      this.showCreateCaseModel = false
      this.ShowCaseActionModal = false
      this.ShowCaseUpdateModal = false
    },
  },
  watch: {
    selectedDepartment(val) {
      this.selectedSubDepartment = null
      this.subDepartments = []
      if (val) {
        if (typeof val["subDepartments"] != "undefined") {
          this.subDepartments = val.subDepartments
          if (val.subDepartments.length > 0) {
            this.selectedSubDepartment = val.subDepartments[0]._id
            this.assignedTo = null
          }
        }
      }
    },
    selectedSubDepartment(val) {
      this.assignedTo = null
      let subdepartFullObj = []
      if(val){
        subdepartFullObj = this.selectedDepartment.subDepartments.filter(item=>{
          return item._id == val
        })

        if(subdepartFullObj.length > 0){
          this.assigneeList = subdepartFullObj[0]?.assignees
        }
      }

    },
  }
}
</script>